import React from 'react'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import { setStartDate, setView } from '../../../redux/actions/setFilters'
import { calendarPopoverTitleDateFormat as titleDateFormat } from '../../../configuration/configs'
import useKeyPressEvent from '../../../utilities/events/useKeyPressEvent'
import labels from '../../../configuration/labels'
import views from '../../../configuration/views'

import '../../../styles/scss/components/calendar/date-cell-popover-content.scss'

const DateCellPopoverContent = ({ day, selectedDate, closeEventsPopover, renderPopoverEvents }) => {
  const dispatch = useDispatch()

  // onClick of CTA close unset selected date cell & popup,
  // set active date and redirect user to the grid cards view
  const handleViewDay = () => {
    dispatch(setStartDate(moment(day)))
    dispatch(setView(views.daily))
  }

  // onKeyDown for esc unset selected date cell & popup
  useKeyPressEvent('Escape', closeEventsPopover)

  return (
    <div className="date-cell-popover__content">
      <div className="date-cell-popover__content-header">
        <h6>
          {moment(day).format(titleDateFormat)}
          <button className="content-header__close" onClick={closeEventsPopover}>
            {labels.calendarCtaClose}
          </button>
        </h6>
      </div>

      {renderPopoverEvents && (
        <div className="date-cell-popover__content-body">
          {renderPopoverEvents}
          <button className="cta__view-daily-events" onClick={() => handleViewDay()}>
            {labels.calendarCtaViewDay}
          </button>
        </div>
      )}
    </div>
  )
}

export default DateCellPopoverContent
